import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { User } from '../../../../../../../model/user/User';

interface IBrandSignAnnexModalProps {
    show: boolean;
    closeModal: () => void;
    action: () => void;
    disableButton: boolean;
    grandTotal: string | 0;
    nbPosts?: number;
    user?: User;
}

/** Confirmation the brand gives before the amendment is sent to the influencer */
export function BrandSignAnnexModal({
    show,
    closeModal,
    action,
    disableButton,
    grandTotal,
    nbPosts,
    user,
}: IBrandSignAnnexModalProps) {
    const { t } = useTranslation();
    const [isAccepted, setIsAccepted] = useState(false);
    const prefix = 'brand.campaign.book.contract.modal.annex';

    const sign = () => {
        if (isAccepted) {
            action();
            closeModal();
        }
    };

    return (
        <Modal show={show} onHide={closeModal} className="modal-dark" centered={true}>
            <Modal.Body>
                <div className="mt-4 d-flex align-items-center justify-content-center flex-column">
                    <h4 className="text-primary text-center">{t(`${prefix}.sign_title`)}</h4>
                </div>
                <div className="text-center">
                    <p>
                        {t(`${prefix}.sign_desc`, { name: `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim() })}
                    </p>
                    <div className="d-flex align-items-center justify-content-center">
                        <div className="d-flex align-items-center mr-1">
                            <h6 className="text-primary mr-1">{!!nbPosts ? nbPosts : ''}</h6>
                            <h6>
                                {nbPosts === 0
                                    ? t('brand.campaign.book.offer.addons_only')
                                    : t('brand.campaign.book.offer.content_pieces')}
                            </h6>
                        </div>
                        <h6 className="euro-symbol text-primary">{grandTotal}</h6>
                    </div>
                    <div className="bg-light default-radius p-3 text-muted font-12 mt-3">
                        {t(`${prefix}.sign_hint`)}
                    </div>
                </div>
                <div className="d-flex align-items-center mt-3">
                    <Checkbox
                        className="mb-0"
                        required
                        id="annex-terms-checkbox"
                        onChange={event => setIsAccepted(event.target.checked)}
                        color="primary"
                        checked={isAccepted}
                    />
                    <label
                        htmlFor="annex-terms-checkbox"
                        className="text-start cursor-pointer mb-0 text-muted"
                        dangerouslySetInnerHTML={{ __html: t('brand.campaign.book.offer.terms') }}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button onClick={closeModal} variant="outline-primary" className="btn-sm mx-2">
                    {t('general.button.cancel')}
                </Button>
                <Button
                    disabled={!isAccepted || disableButton}
                    variant="primary"
                    className="btn-sm mx-2"
                    onClick={sign}
                >
                    {t('brand.campaign.book.contract.sign')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
